import React, { useEffect, useState } from 'react';
import '../../App.css';
import { Link } from 'react-router-dom';

import axios from 'axios';
//import { useDrag } from 'react-dnd';
//import { useDrag, DndProvider } from 'react-dnd';
//import { useDrop } from 'react-dnd';
//import { HTML5Backend } from 'react-dnd-html5-backend';
// Layouts -----------------------
import Lay01 from '../partils/layoutposts/lay01';
import Lay02 from '../partils/layoutposts/lay02';
import Lay03 from '../partils/layoutposts/lay03';

import Lay04 from '../partils/layoutposts/lay04';
import Lay05 from '../partils/layoutposts/lay05';
import Lay06 from '../partils/layoutposts/lay06';

import Lay07 from '../partils/layoutposts/lay07';
import Lay08 from '../partils/layoutposts/lay08';
import Lay09 from '../partils/layoutposts/lay09';

import Lay10 from '../partils/layoutposts/lay10';
import Lay11 from '../partils/layoutposts/lay11';
import Lay12 from '../partils/layoutposts/lay12';

import Lay13 from '../partils/layoutposts/lay13';
import Lay14 from '../partils/layoutposts/lay14';
import Lay15 from '../partils/layoutposts/lay15';

import Lay16 from '../partils/layoutposts/lay16';
import Lay17 from '../partils/layoutposts/lay17';
import Lay18 from '../partils/layoutposts/lay18';

import Lay19 from '../partils/layoutposts/lay19';
import Lay20 from '../partils/layoutposts/lay20';
import Lay21 from '../partils/layoutposts/lay21';

import datall from '../../local/data'
import datapresetcolor from '../../local/configpresetcores'
import { useFont } from '../../ContextFont';
import '../../../src/App.css';

import ImgLoading from '../../acets/loading4.gif'

import IcoReload from'../../acets/icon/reload.svg'
import IcoEdit from'../../acets/icon/edit.svg'
import IcoValues from'../../acets/icon/values.svg'

import Colorpreset from '../../components/partils/presets/colorposts'
import Lay22 from '../partils/layoutposts/lay22';
import Lay23 from '../partils/layoutposts/lay23';
import Lay24 from '../partils/layoutposts/lay24';
import Lay25 from '../partils/layoutposts/lay25';
import Lay26 from '../partils/layoutposts/lay26';
import Lay27 from '../partils/layoutposts/lay27';

import Lay28 from '../partils/layoutposts/lay28';
import Lay29 from '../partils/layoutposts/lay29';
import Lay30 from '../partils/layoutposts/lay30';
import Lay31 from '../partils/layoutposts/lay31';
import Lay32 from '../partils/layoutposts/lay32';
import Lay33 from '../partils/layoutposts/lay33';
import Lay34 from '../partils/layoutposts/lay34';
import Lay35 from '../partils/layoutposts/lay35';
import Lay36 from '../partils/layoutposts/lay36';
import Lay37 from '../partils/layoutposts/lay37';
import Lay38 from '../partils/layoutposts/lay38';
import Lay39 from '../partils/layoutposts/lay39';
import Lay41 from '../partils/layoutposts/lay41';
import Lay40 from '../partils/layoutposts/lay40';
import Lay42 from '../partils/layoutposts/lay42';
import Lay43 from '../partils/layoutposts/lay43';
import Lay44 from '../partils/layoutposts/lay44';
import Lay45 from '../partils/layoutposts/lay45';
//--------------------------------
let page = 1;
export default function Engine() {
  const [trapColor, setTrapColor] = useState('#237ce2');
  const [textColor, setTextcolor] = useState('#FAFAFA');
  const [titlesize, setTitlesize] = useState(22);
  const [boxtitlesize, setBoxtitlesize] = useState();

  const [subtitlesize, setSubtitlesize] = useState(12);
  const [subtextColor, setSubtextColor] = useState('#000000');
  
  const [inclinacao, setInclinacao] = useState(80);

  const [loadinai, setLoadinai] = useState(false);
  const [modalmenu, setModalmenu] = useState(false)

  const [modalrow1, setModalrow1] = useState(false);
  const [modalrow2, setModalrow2] = useState(false);
  const [modalrow3, setModalrow3] = useState(false);
  const [modalrow4, setModalrow4] = useState(false);

  const [modalEditText,setModalEditText]=useState(false)

  const [modalqueryunsp,setModalqueryunsp]=useState(false)
  const [imgU, setImgU]=useState()

  const [modaldata, setModaldata] = useState(true);
  const [datal, setdatal] = useState(datall);
  const initialValues={ // DEFININDO UMA CONST PARA O STATE INICIAL 
    titulo:'PROMOÇÃO',	status: '',	subtitulo: 'Não perca essa oportunidade',	instagram: '',	email: '',	detalhes: '',preco:'', segmento:'', nome:'',sobre:''
  }
  const [values, setValues]=useState(initialValues) // INICIANDO UM STATE
  const [backgroundImage, setBackgroundImage] = useState(
    "https://cdn.casaeculinaria.com/wp-content/uploads/2023/04/05163949/Hamburguer-artesanal.webp"
  );
  const valuestrue = JSON.parse(localStorage.getItem('formValuesGerarPostHellopost'))
  useEffect(() => {
    valuestrue&&setValues(valuestrue)
  }, []); 

  
  const handleColorChange = (event) => {
    setTrapColor(event.target.value);
  };
  const handleColorTextChange = (event) => {
    setTextcolor(event.target.value);
  };
  const handleTextChange = (event) => {
    setTitlesize(event.target.value);
  };
  const handleBoxTextChange = (event) => {
    setBoxtitlesize(event.target.value);
  };

  const handlesubTextChange = (event) => {
    setSubtitlesize(event.target.value);
  };
  const handleColorsubChange = (event) => {
    setSubtextColor(event.target.value);
  };

  const handleInclinacaoChange = (event) => {
    setInclinacao(event.target.value);
  };

  const estadosModais = [setModalrow1, setModalrow2, setModalrow3, setModalrow4];

  const gerarEstadoAleatorio = () => {
    if(values.segmento===''||values.instagram===''){
      alert("Atenção, para gerar sem IA preencha somente o campo de SEGMENTO e INSTAGRAM ;D")
    }else{
      console.log(values)
      localStorage.setItem('formValuesGerarPostHellopost', JSON.stringify(values));
      // Primeiro, redefina todos os estados modais para 'false' RANDON
      estadosModais.forEach((setModal) => setModal(false));
      // Em seguida, selecione aleatoriamente um estado modal para definir como 'true'
      const indiceAleatorio = Math.floor(Math.random() * estadosModais.length);
      fetchApiButton()
      estadosModais[indiceAleatorio](true);
      setModaldata(false);
    }
  };

    //getclin.kinghost.net/postig
    //http://getclin.kinghost.net:21005/apiHP/chatassistente
    //http://localhost:3008/apiHP/chatassistente

    function gerarcomIA() {
      if (values.segmento === '' || values.nome === '' || values.instagram === '' || values.sobre === '') {
        alert("Atenção, preencha todos os campos ;D");
      } else {
        localStorage.setItem('formValuesGerarPostHellopost', JSON.stringify(values));
        gerarEstadoAleatorio();
        console.log(values);
        setModaldata(false);
        setLoadinai(true);
        
        axios.post('http://getclin.kinghost.net:21005/apiHP/chatassistente', values)
          .then(res => {
            setdatal(res.data);
            setLoadinai(false);
            fetchApiButton()
          })
          .catch(error => {
            console.error("Erro na requisição:", error);
            alert("Ocorreu um erro na comunicação com o servidor. Verifique a internet e tente novamente mais tarde.");
            setLoadinai(false);
          });
      }
    }

  const handleImageUpload = (event) => {
    const file = event.target.files[0]; // Pega o arquivo carregado

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        // Atualize o estado com a nova imagem de fundo
        setBackgroundImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  function onChange(ev) {//ALTERAR OS STATES DOS INPUTS
    const {name, value} = ev.target; //ESTRAIR O NAME E VALUE DO EV
    setValues({ ...values, [name]:value }); //SETANDO O VALUE EM NAME
  }
// DRAG --------------------------------------------------------------------

//dDRAG -------------------------------------------------------------------
  

  const finalpresetcolor = datapresetcolor.map(
  namesString =>
  <div className='row between pp ma5 w30 m5 borda1m2' 
    key={namesString.id}
    onClick={() => {
    setTrapColor(namesString.trap);
    setTextcolor(namesString.textcolor); 
    setSubtextColor(namesString.subtitlecolor);
    //setTitlesize(24);
    //setSubtitlesize(14);
    //setBoxtitlesize(80)
      }}>
    <div className='w33 h2' style={{background:namesString.trap}}></div>
    <div className='w33 h2' style={{background:namesString.textcolor}}></div>
    <div className='w33 h2' style={{background:namesString.subtitlecolor}}></div>
  </div>
)
// ===================================contx global
const { fonte, alterarFonte,imagens, adicionarImagem } = useFont();

function handleClick(gfont) {
  alterarFonte(gfont);
  document.body.className = gfont;
  console.log(gfont);
}


//===============================================
//================UNSPLASH==========
//https://api.unsplash.com/search/collections?page=1&query=office
//https://api.unsplash.com/photos/?client_id=QLBGRA5h0l_koAVhav0Iot98kr161srcv7zbZVxdtCk


const [isFetching, setIsFetching] = useState(false);

const fetchApiButton = async () => {
  
  if (isFetching) {
    // Se já estiver fazendo uma requisição, não faça nada
    return;
  }
  setIsFetching(true); // Marca que uma requisição está em andamento ${values.segmento}
  try {
    const response = await axios.get(`https://api.unsplash.com/search/photos?page=${page}&query=${values.segmento}&client_id=QLBGRA5h0l_koAVhav0Iot98kr161srcv7zbZVxdtCk`);
    adicionarImagem(response.data.results);
    page++; // Incrementa a página após a requisição
  } catch (error) {
    console.error('Erro na chamada da API:', error);
  } finally {
    setIsFetching(false); // Marca que a requisição foi concluída
  }
};
//ERR_NETWORK cod
//================================
return (
    <div className={`w100 h100 row center b33`}>
      {loadinai&&
      <div className='w100 h100 fundo-opaco column center posifixedinicio z18'>
        <div className='column b2 p30 cont-circ7 cell-tamanho75'>
          <img src={ImgLoading} alt='loading' className='w50'/>
          <h5 className='c1'>Carregando...</h5>
          <label className='c1 cen'>Aguarde, gerando textos com inteligencia artificial</label>
          <label  className='c1'>Tempo médio 3min</label>
        </div>
      </div>
      }
     {modalEditText && (
        <div className='w100 h110 column center posifixedinicio fundo-opaco z17 '>
          <div className='row borda1m2 cont-circ7 w33 p30 ma10b0 h50 celular b2 cell-tamanho75'>
            <h5 className='w100'>Importar array JSON ou Editar em lote</h5>
            <label>Esse recurso permite que você importe diretamente do chatgpt o array de objetos como o modelo de dados abaixo. sendo um aray de até 3 objetos JSON. ou você pode editar o texto para aplicar em todos os posts de uma só vez.</label>
            <textarea
              rows={20}  // Número de linhas
              style={{ height: '50vh' }}  // Altura em pixels
              name="text"
              value={JSON.stringify(datal)}
              onChange={(e) => setdatal(JSON.parse(e.target.value))}
            ></textarea>
            <button 
            className='w100'
            onClick={() => setModalEditText(false)}>Sair</button>
          </div>
        </div>
      )}

      {modaldata&& // NOVO POST
      <div className='w100 h110 column center posifixedinicio b2 z18 '>
        
        <div className='row bordaElements cont-circ7 w33 p30 ma10b0 celular b2 cell-tamanho75'>
          <h5 className='w100'>Novo Post</h5>
          {/*
          <div className='row between w100 p10'>
            <div className='w50 row'>
              <div>
                <input type='checkbox' id='br'></input>
              </div>
              <label for="br">Brasil</label>
            </div>
            <div className='w50 row'>
              <input type='checkbox' id='eua'></input>
              <label for="eua">EUA</label>
            </div>
          </div>

<option value={"Art%20and%20culture"}>Arte e Cultura</option>
<option value={"Cleaning%20services"}>Serviços de Limpeza</option>
<option value={"Business%20Consulting%20Services"}>Serviços de Consultoria Empresarial</option>
<option value={"Event%20Services"}>Serviços de Eventos</option>
<option value={"Transportation%20and%20logistics"}>Transporte e Logística</option>
     */}

            
            <label className='w100'>Segmento:</label>
              <select name="segmento"  onChange={onChange} value={values.segmento}
              style={{ border: values.segmento === '' ? '#F9B3B3 1px solid' : '#9DDE69 1px solid'}}
              >
              <option value={""}>Selecione o segmento</option>
              <option value={"Agribusiness"}>Agronegócio</option>
              <option value={"fastfood"}> Alimentação e Restaurantes</option>
              <option value={"cosmetic"}>Beleza e Estética</option>
              <option value={"Construction%20and%20Renovation"}>Construção e Reforma</option>
              <option value={"E-commerce"}>Comércio Eletrônico</option>
              <option value={"Education%20and%20Teaching"}>Educação e Ensino</option>
              <option value={"Marketing"}>Marketing e Publicidade</option>
              <option value={"financial%20services"}>Serviços Financeiros</option>
              <option value={"Health%20and%20wellness"} >Saúde e Bem-Estar</option>
              <option value="Technology">Tecnologia da Informação</option>
              
            
              <option value={""}>------------AUTONOMOS------------</option>
              <option value={"Architect"} >Arquiteto</option>
              <option value={"Engineer"}>Engenheiro</option>
              <option value={"Psychologist"}>Psicólogo</option>
              <option value={"attorney"}>Advogado</option>
              <option value={"Fisioterapeuta"}>Fisioterapeuta</option>
              <option value={"CAR"}>Oficina</option>
              <option value={"driver"}>Motorista</option>
            </select>

            <div className='w100 row between'>
              <div className='column w45'>
              <label className='w100'>instagram, site ou  WhatsApp</label>
              <input type="text"  
                style={{ border: values.instagram === '' ? '#F9B3B3 1px solid' : '#9DDE69 1px solid'}}
                name="instagram"  
                onChange={onChange} 
                placeholder='hellopost.com.br'
                value={values.instagram}
                autoComplete='off'
              />
              </div>
              <div className='column w45'>
                  <label className='w100'>Cor da sua Logo(opcional)</label>
                  <input type="color" className="w100" onChange={handleColorChange} value={trapColor} />
                </div>
            </div>
            <label className='w100'>Nome do negócio / Name:</label>
            <input
                type="text"
                name="nome"
                onChange={onChange}
                value={values.nome}
                autoComplete='off'
                placeholder='Nome do negócio'
                style={{ border: values.nome === '' ? '#F9B3B3 1px solid' : '#9DDE69 1px solid'}}
              />


            <label className='w100'>Sobre você ou a sua empresa:"prompt"</label>
            <input type="text"  
              name="sobre"  
              onChange={onChange} 
              value={values.sobre} 
              autoComplete='off'
              style={{ border: values.sobre === '' ? '#F9B3B3 1px solid' : '#9DDE69 1px solid'}}
              />
            <div className='row between w100 ma15b0'>
              
              <div 
              className='w30 b22 cell-tamanho column bordaElements p10 pp cont-circ10'
              onClick={() => { gerarEstadoAleatorio();  }}> 
              Sem IA 
              <label className='pp fs06m c1'>Generate less AI</label>
              </div>
              <label className=' cell-tamanho column w10 h5 column center'>Ou - Or</label>
              <div 
              className='w30 b22 cell-tamanho column bordaElements p10 pp cont-circ10'
              onClick={() => {gerarcomIA(); }}>
                Com IA
                <label className='pp fs06m c1'>Generate with AI</label>
              </div>
            </div>
            <Link to="/painel" 
            className='w100 pp cell-tamanho column'
            > Cancel - Voltar </Link>
          </div>
      </div>
      }

      {modalmenu&&

      <div className='w20 b2 h100 row  cell-tamanho cell-card100'>
        
          <div className='w100 column desktop-none'>
            
            <div className='w80 c2 fim p10'>
              <img src='https://cdn-icons-png.flaticon.com/128/7303/7303544.png' alt='Role para baixo' className='w20'/>
            </div>
            <label className='w80 c1 fim p10'> Role para baixo</label>
            <label className='w80 c1 fim p10'> Scroll down</label>
            <div className='w80 row end p10'>
              <label className='w50 c1'>
                Faça edições e acompanhe o resultado em tempo real. Make edits and track the result in real time
              </label>
              
            </div>
          </div>
        

        <div className='w20 h100 column center posifixedinicio cell-tamanho-metade z18 b-vidro borda1 cell-card100'>
          <h6 className='w80 c1'>Geral</h6>
          <div className='column borda1 cont-circ7 w80 p2 ma10b0 celular'>
            <div className='row w100'>
              <div className='w80'> 
                <div className='w100'>
                  <label className='c4 fw500 fs08em'>Transparencia</label>
                  <input type='range' min={1} max={100} onChange={handleInclinacaoChange} value={inclinacao}></input>
                </div>
                <div className='w100'>
                  <label className='c4 fw500 fs08em'>Caixa de texto</label>
                  <input type='range' min={34} max={240} onChange={handleBoxTextChange} value={boxtitlesize}></input>
                </div>
              </div>
              <div className='column w20'>
                <label className='c4 fw500 fs08em'>Fundo</label>
                <input type="color" onChange={handleColorChange} value={trapColor} />
              </div>
            </div>
          </div>

          
          <div className='column borda1 cont-circ7 w80 p2  celular'>
            <div className='row w100'>
              <div className='w80'>
                <label className='fs0p8 c4 fw500 fs08em'>Titulo - {titlesize}</label>
                <input type='range' min={12} max={35} onChange={handleTextChange} value={titlesize}></input>
              </div>
              <div className='column w20'>
                <label className='c4 fw500 fs08em'>Titulo</label>
                <input type="color" value={textColor} onChange={handleColorTextChange}  />
              </div>
            </div>
          </div>
          
          
          <div className='column borda1 cont-circ7 w80 p2 ma10b0 celular'>
            <div className='row w100'>
              <div className='w80'>
                <label className='c4 fw500 fs08em'>Subtitulo - {subtitlesize}</label>
                <input type='range' min={9} max={20} onChange={handlesubTextChange} value={subtitlesize}></input>
              </div>
              <div className='column w20'>
                <label className='c4 fw500 fs08em'>Sub.T</label>
                <input type="color" onChange={handleColorsubChange} value={subtextColor} />
              </div>
            </div>
          </div>

          <div className='column borda1 cont-circ7 w80 p2 celular'>
            <div className='row w100'>
              <div className='w100'>
                <label className='c4 fw500 fs08em'>Fonte</label>
                <div className='w100 row between'>
                  <div className="w30 column center pp " onClick={() => handleClick('fonte-nunito')}>
                    <label className='c4 fs2em fonte-nunito cell-text-smile'>Aa</label>
                    <label className='c1 fonte-nunito'>Nunito</label>
                  </div>
                  <div className='w30 column center pp ' onClick={() => handleClick('montserrat')}>
                    <label className='c4 fs2em montserrat cell-text-smile'>Aa</label>
                    <label className='c1 fonte-nunito'>montserrat</label>
                  </div>
                  <div className='w30 column center pp' onClick={() => handleClick('roboto')}>
                    <label className='c4 fs2em roboto cell-text-smile'>Aa</label>
                    <label className='c1 fonte-nunito'>roboto</label>
                  </div>
                  <div className='w30 column center pp' onClick={() => handleClick('fonte-librie')}>
                    <label className='c4 fs2em fonte-librie cell-text-smile'>Aa</label>
                    <label className='c1 fonte-nunito'>Libre</label>
                  </div>
                  <div className='w30 column center pp ' onClick={() => handleClick('babes')}>
                    <label className='c4 fs2em babes cell-text-smile'>Aa</label>
                    <label className='c1 fonte-nunito'>babes</label>
                  </div>
                  <div className='w30 column center pp ' onClick={() => handleClick('fonte-play')}>
                    <label className='c4 fs2em fonte-play cell-text-smile'>Aa</label>
                    <label className='c1 fonte-nunito'>Paly</label>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>

          <div className='column borda1 cont-circ7 w80 p2 ma10b0 celular'>
            <div className='row w100'>
              <div className='w80 row around'>
                <label className='c4 fw500 fs08em w100'>Preset de cores</label>
                {finalpresetcolor}
              </div>
            </div>
          </div>
        
          <div className='row borda1 cont-circ7 w80 p2  celular'>
            <label className='c4 fw500 fs08em'>Imagem de fundo IA:</label>
            <div className='row between'>
              <div onClick={fetchApiButton} className={`w80 h5 fs08em cont-circ8 pp b3 row center cell-tamanho80 ${isFetching ? 'disabled' : ''}`}>
                  Gerar+10Img 
                  <img src={IcoReload} alt='IcoRload' className='w20'/>
              </div>
              <div className='w20 b3 column center pp h5 cont-circ8' onClick={()=>setModalqueryunsp(!modalqueryunsp)}>
                {modalqueryunsp?
                <img src='https://cdn-icons-png.flaticon.com/128/70/70287.png' alt="pesquisar search" className='w40'/>
                  :
                  <img src='https://cdn-icons-png.flaticon.com/128/79/79558.png' alt="pesquisar search" className='w40'/>
                  }
              </div>
            </div>
           
            {modalqueryunsp&&
            <>
            <label className='c4 fw500 fs08em'>Pesquisar Imagens</label>
              <input type='text' className='c3' name='segmento' value={values.segmento} onChange={onChange}/>
              </>
            }</div>
          <div className='row start borda1 cont-circ7 w80 p2 celular ma5'>
            <label className='c4 fw500 fs08em'>Preço:</label>
            <input type='number' name="preco" value={values.preco} onChange={onChange}></input>
            <label className='c4 fw500 fs08em'>Enviar Imagem de fundo:</label>
            <div className='w100 ma10b0  '>
              <input  className="cell-tamanho"type="file" accept="image/*" onChange={handleImageUpload} />
            </div>
          </div>
          
        </div>
        
      </div>
      }
      <div className='w80 row center b33 cell-tamanho90 ma50b0'>
        <div className='w79 h10 linha row between b2 posifixedinicio z17 cell-tamanho'>
          <div className='row w50 cell-none'>
            <div 
              className='w20 h5 fs08em cont-circ8 pp b3 row center cell-tamanho-metade30 m10'
              onClick={() => setModalmenu(!modalmenu)}>
              {modalmenu ? "Fechar" : "Editar"}
              <img src={IcoValues} alt='IcoValues' className='w25'/>
            </div>
            <div onClick={fetchApiButton} 
            className={`w25 h5 fs08em cont-circ8 pp b3 row center cell-tamanho-metade30 m10 ${isFetching ? 'disabled' : ''}`}>
              Imagens + 10
              <img src={IcoReload} alt='IcoRload' className='w25'/>
            </div>
          </div>
          <div className='column center w10 cell-tamanho-metade30'>
            <label>Models</label>
            <label>45</label>
          </div>
          <div className='column center w10 cell-tamanho-metade30'>
            <label>Tokens</label>
            <label>5</label>
          </div>
            <Link to="/painel" className='pp p10 b2 borda1 cont-circ15'>
              <label className='pp'>Voltar home</label>
            </Link>
        </div>
        <div className='w100 row center h90 celular'>
          <div className='w50 row center h5 cell-none  w100 '>
            
            {/*
            <div onClick={()=>setModalEditText(true)} className="w15 h5 fs08em cont-circ8 pp b3 row center  cell-tamanho-metade30 m10">
              Texto JSON
              <img src={IcoEdit} alt='IcoEdit' className='w25'/>
            </div>
            */}
            
          </div>

          <div 
              className='w33 h5 fs08em cont-circ8 pp b-vidro row center z16 m10 desktop-none posifixedfim20 rigth20 borda1m2 '
              onClick={() => setModalmenu(!modalmenu)}>
              {modalmenu ? "Fechar" : "Edit"}
              <img src={IcoValues} alt='IcoValues' className='w25'/>
          </div>

        {//modalrow1&& 
        <div className='row between w90 ma10b0 celular cell-tamanho'>
          <Lay01 
         trapColor={trapColor} 
         titlesize={titlesize}
         textColor={textColor}
         subtitlesize={subtitlesize} 
         subtextColor={subtextColor} 
         backgroundImage={backgroundImage}
         boxtitlesize={boxtitlesize}
         inclinacao={inclinacao}
         datal={datal[0]}
         datav={values}
         img={imgU}
        />
        <Lay02 
         trapColor={trapColor} 
         subtitlesize={subtitlesize} 
         subtextColor={subtextColor} 
         datav={values}
         datal={datal[1]}
        />
        <Lay03
          inclinacao={inclinacao}
          trapColor={trapColor} 
          titlesize={titlesize}
          textColor={textColor}
          subtitlesize={subtitlesize} 
          subtextColor={subtextColor} 
          datav={values}
          datal={datal[2]}
        />
         

        </div>
          }
          {//modalrow2&& 
          <div className='row between w90 ma10b0 celular cell-tamanho'>
            <Lay04 
              trapColor={trapColor} 
              titlesize={titlesize}
              textColor={textColor}
              subtitlesize={subtitlesize} 
              subtextColor={subtextColor} 
              datal={datal[3]}
              datav={values}
              backgroundImage={backgroundImage}
            />
            
            {
              // ================== 
            }
            <Lay05 
             trapColor={trapColor} 
             titlesize={titlesize}
             textColor={textColor}
             subtitlesize={subtitlesize} 
             subtextColor={subtextColor} 
             datal={datal[4]}
             datav={values}
            />
            {
              // ================== 
            }
            <Lay06
             trapColor={trapColor} 
             titlesize={titlesize}
             textColor={textColor}
             subtitlesize={subtitlesize} 
             subtextColor={subtextColor} 
             datal={datal[5]}
             datav={values}
            />

          </div>
          }
          {
            // ==================  NOVA LINHAAAAAA
          }
          {//modalrow3&& 
          <div className='row between w90 ma10b0 celular cell-tamanho'>
              {
              // ==================  
              }
              <Lay07 
                trapColor={trapColor} 
                titlesize={titlesize}
                textColor={textColor}
                subtitlesize={subtitlesize} 
                subtextColor={subtextColor} 
                datal={datal[0]}
                datav={values}
                backgroundImage={backgroundImage}
              />
              {
              // ==================  
              }
             <Lay08
                trapColor={trapColor} 
                titlesize={titlesize}
                textColor={textColor}
                subtitlesize={subtitlesize} 
                subtextColor={subtextColor} 
                boxtitlesize={boxtitlesize}
                datal={datal[1]}
                datav={values}
                backgroundImage={backgroundImage}
                inclinacao={inclinacao}
              />
              {
              // ==================
              }
               <Lay09
                trapColor={trapColor} 
                titlesize={titlesize}
                textColor={textColor}
                subtitlesize={subtitlesize}
                boxtitlesize={boxtitlesize}
                subtextColor={subtextColor} 
                datal={datal[2]}
                datav={values}
                backgroundImage={backgroundImage}
              />

          </div>

          }

          {
            // ==================  NOVA LINHAAAAAA
          }
          {//modalrow4&& 
          <div className='row between w90 ma10b0 celular cell-tamanho'>
              {
              // ==================  
              }
             <Lay10
                trapColor={trapColor} 
                titlesize={titlesize}
                textColor={textColor}
                subtitlesize={subtitlesize} 
                subtextColor={subtextColor} 
                datal={datal[3]}
                datav={values}
                backgroundImage={backgroundImage}
              />
            <Lay11
                trapColor={trapColor} 
                titlesize={titlesize}
                textColor={textColor}
                subtitlesize={subtitlesize} 
                subtextColor={subtextColor} 
                boxtitlesize={boxtitlesize}
                datal={datal[4]}
                datav={values}
                backgroundImage={backgroundImage}
                inclinacao={inclinacao}
              /> 
             <Lay12
                trapColor={trapColor} 
                titlesize={titlesize}
                textColor={textColor}
                subtitlesize={subtitlesize} 
                subtextColor={subtextColor} 
                backgroundImage={backgroundImage}
                boxtitlesize={boxtitlesize}
                inclinacao={inclinacao}
                datal={datal[5]}
                datav={values}
              />
          </div>
          }
          {//modalrow4&& 
          <div className='row between w90 ma10b0 celular cell-tamanho'>
          {
          // ==================  
          }
         <Lay13
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            datal={datal[0]}
            datav={values}
            backgroundImage={backgroundImage}
          />
        <Lay14
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            datal={datal[1]}
            datav={values}
            backgroundImage={backgroundImage}
          /> 
         <Lay15
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[2]}
            datav={values}
          />
      </div>
      }
      {//modalrow4&& 
          <div className='row between w90 ma10b0 celular cell-tamanho'>
          {
          // ==================  
          }
         <Lay16
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            datal={datal[3]}
            datav={values}
            boxtitlesize={boxtitlesize}
            backgroundImage={backgroundImage}
          />
        <Lay17
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            datal={datal[4]}
            boxtitlesize={boxtitlesize}
            datav={values}
            backgroundImage={backgroundImage}
          /> 
         <Lay18
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[5]}
            datav={values}
          />
      </div>
      }
      {//modalrow4&& 
          <div className='row between w90 ma10b0 celular cell-tamanho'>
          {
          // ==================  
          }
         <Lay19
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            datal={datal[0]}
            datav={values}
            backgroundImage={backgroundImage}
          />
        <Lay20
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            boxtitlesize={boxtitlesize}
            datal={datal[1]}
            datav={values}
            backgroundImage={backgroundImage}
          /> 
         <Lay21
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[2]}
            datav={values}
          />
      </div>
      }

  <div className='row between w90 ma10b0 celular cell-tamanho'>
          <Lay22
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[3]}
            datav={values}
          />
          <Lay23
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[4]}
            datav={values}
          />
          <Lay24
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[5]}
            datav={values}
          />
  </div>
  <div className='row between w90 ma10b0 celular cell-tamanho'>
          <Lay25
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[0]}
            datav={values}
          />
          <Lay26
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[1]}
            datav={values}
          />
          <Lay27
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[2]}
            datav={values}
          />
  </div>
  <div className='row between w90 ma10b0 celular cell-tamanho'>
          <Lay28
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[3]}
            datav={values}
          />
          <Lay29
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[4]}
            datav={values}
          />
          <Lay30
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[5]}
            datav={values}
          />
  </div>  

  <div className='row between w90 ma10b0 celular cell-tamanho'>
        <Lay31
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[0]}
            datav={values}
          />
        <Lay32
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[1]}
            datav={values}
          />
        <Lay33
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[2]}
            datav={values}
          />
  </div>
  <div className='row between w90 ma10b0 celular cell-tamanho'>
        <Lay34
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[0]}
            datav={values}
          />
        <Lay35
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[1]}
            datav={values}
          />
        <Lay36
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[2]}
            datav={values}
          />
  </div>
  <div className='row between w90 ma10b0 celular cell-tamanho'>
        <Lay37
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[0]}
            datav={values}
          />
        <Lay38
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[1]}
            datav={values}
          />
        <Lay39
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[2]}
            datav={values}
          />
  </div>
  <div className='row between w90 ma10b0 celular cell-tamanho'>
        <Lay40
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[0]}
            datav={values}
          />
        <Lay41
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[1]}
            datav={values}
          />
        <Lay42
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[2]}
            datav={values}
          />
  </div>
  <div className='row between w90 ma10b0 celular cell-tamanho'>
        <Lay43
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[0]}
            datav={values}
          />
        <Lay44
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[1]}
            datav={values}
          />
        <Lay45
            trapColor={trapColor} 
            titlesize={titlesize}
            textColor={textColor}
            subtitlesize={subtitlesize} 
            subtextColor={subtextColor} 
            backgroundImage={backgroundImage}
            boxtitlesize={boxtitlesize}
            inclinacao={inclinacao}
            datal={datal[2]}
            datav={values}
          />
  </div>






        </div>
      </div>
    </div>
  );
}


